// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"58ff19f9","222":"521c219c","478":"f7a21ad5","772":"802bb118","810":"55bb3324","812":"a3085d85","860":"28242388"}[chunkId] + ".chunk.js";
};